import { render } from "./MethodLabel.vue?vue&type=template&id=556c054d&lang=pug"
import script from "./MethodLabel.vue?vue&type=script&lang=js"
export * from "./MethodLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__